import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {Query} from "react-apollo";
import {EDI_MESSAGE} from "../../queries/shipping";

const EdiMessagePropertiesPanel = (props) => {

  let elements = null;
  if (!props.id || props.id === "") {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "id", label: "Id", type: "id"},
      {prop: "messageType", label: "Type", type: "string"},
      {prop: "orderId", label: "Order Id", type: "shippingOrderId"},
      {prop: "filename", label: "Filename", type: "string"},
      {prop: "status", label: "Status", type: "string"},
      {prop: "errorMsg", label: "Error Msg", type: "string"},
      {prop: "updatedAt", label: "Updated", type: "utc"},
      {prop: "insertedAt", label: "Created", type: "utc"},
    ])
    let variables = {id: props.id}
    elements = (
      <Query query={EDI_MESSAGE} variables={variables} skip={props.id === ""} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return (
            <PropertiesList properties={properties} data={fromJS(data.incomingEdiMessage)} />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="EDI Message" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default EdiMessagePropertiesPanel;